/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  GROUP_DASHBOARD_COMPONENTS_CHANGE,
  REQUEST_TOP_SUB_GROUP,
  FETCH_TOP_SUB_GROUP_SUCCESS,
  FETCH_TOP_SUB_GROUP_FAILURE,
} from './actionTypes';
import { isEqual } from '../../utils/lodash-utils';
const groupsDashboard = (state = {
    isFetching: false,
    didTopSubGroupsInvalidate: false,
    groupDashboardComponents:{
        showOpenAlarms:true,
        showDevicesByRoles:true,
        showTopEntitiesContainer:true,
        showTopTechnologies:true,
        showTopGroups:true,
        showTopDevices:true,
    },
    topSubGroups:[]
}, action) => {
    switch (action.type) {
        case GROUP_DASHBOARD_COMPONENTS_CHANGE:
        return Object.assign({}, state, {
            groupDashboardComponents:action.currentState,

        });
        case REQUEST_TOP_SUB_GROUP:
        return Object.assign({}, state, {
            isFetching: true,
            didTopSubGroupsInvalidate: false
        });
        case FETCH_TOP_SUB_GROUP_SUCCESS:
        const topSubGroups = action.data;

        const topSubGroupsState = Object.assign({}, state, {
            isFetching: false,
            didTopSubGroupsInvalidate: false,
            topSubGroups: topSubGroups,

        });
        return isEqual(topSubGroupsState, state) ? state : topSubGroupsState
        case FETCH_TOP_SUB_GROUP_FAILURE:
        return Object.assign({}, state, {
            isFetching: false,
            didTopSubGroupsInvalidate: true,
            errorMessage: action.errorMessage,
            topSubGroups: []

        });

        default:
        return state
    }
}

export default groupsDashboard
